import { countries, CountryKey } from '../../../constants/countries';

/**
 * The PlaceHub fundraising guarantee cannot be offered to UK charities, so a
 * charity program whose organisation is registered in the UK never sees it.
 * An unknown country is left available, matching the behaviour before this rule.
 */
export const isFundraisingGuaranteeAvailable = (
  organizationCountry?: string | null
): boolean => {
  const key = organizationCountry?.trim().toUpperCase() as
    | CountryKey
    | undefined;
  return !key || countries[key] !== countries.GB;
};
